class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = this.querySelector('.shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name, event) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: "cart-drawer,cart-icon-bubble"
    });    


    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.querySelector('#main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

      cartUpdate(parsedState);
      
      this.updateLiveRegions(line, parsedState.item_count);
      const lineItem =  this.querySelector(`.CartItem-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
      
      this.disableLoading();
      

    }).catch((e) => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      this.querySelector('.cart-errors').textContent = window.cartStrings.error;
      this.disableLoading();
    });
  }

  updateLiveRegions(line, itemCount) {
    
    if (this.currentItemCount === itemCount) {
      this.querySelector(`.Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
           this.querySelector(`.quantity__input`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = this.querySelector('.cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }


  enableLoading(line) {
    const mainCartItems = this;
    if(mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }
  }

  disableLoading() {
    this.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class CartDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  renderContents(parsedState) {
    console.log('CartDrawer renderContents()');
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        if(section.id == 'cart-drawer') {
		  document.querySelector('.cart-count-bubble').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], '.cart-count-bubble');
        }
        document.querySelector(section.id + ' ' + section.selector).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        
      }));
      this.querySelector('[data-drawer-close]').addEventListener('click',this.onCloseButtonClick.bind(this));
      this.open();
      try {
        // look for TryNow selling plan and update copy
        updateProductOptions()
      } catch {
      }
  }
  
  open() {
    this.querySelector('summary').click();
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    console.log('CartDrawer onCloseButtonClick()');
    this.closeMenuDrawer(event);
    event.preventDefault();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.drawer__content'
      }
    ];
  }
  
  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
 
}

customElements.define('cart-drawer', CartDrawer);



class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.target.disabled = true
      event.preventDefault();
      const id = event.target.getAttribute('data-id');
      const quickAddObj = {
        items: [
          {
            id: id,
            quantity: 1
          }
        ]
      }
      theme.addToCart(quickAddObj);
    });
  }
}

customElements.define('quick-add-button', QuickAddButton);

class CartUpsells extends HTMLElement {
  constructor() {
    super();
    this.scroller = this.querySelector('.horizontal-scroller__upsell');
    this.max = 5;
    this.found = 0;
    this.productTitle= this.getAttribute('data-upsell-title') || false;
    this.getUpsells();
    this.productPageScroller = document.querySelector('.product__upsells-scroller');
    
  }
  getUpsells() {
    if(!this.productTitle) return;
    const url = `/collections/you-may-also-like?view=upsells`;
    fetch(url)
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const upsells = doc.querySelectorAll('.upsell');
      upsells.forEach(upsell => {
        if(upsell.getAttribute('data-title') === this.productTitle) return true;
        if(this.found >= this.max) return false;
        this.scroller.appendChild(upsell);
        if(this.productPageScroller && window.productJSON) {
          if(upsell.getAttribute('data-title') === window.productJSON.title) return true;
          const clone = upsell.cloneNode(true);
          clone.removeAttribute('id');
//           this.productPageScroller.appendChild(clone);
        }
        this.found = this.found + 1;
        
      });
      
      if(this.scroller.innerHTML.trim().length === 0) {
        this.scroller.parentNode.style.display = 'none';
      }
    })
    .catch(error => console.log(error));
  }
}

customElements.define('cart-upsells', CartUpsells);


class GiftNoteToggle extends HTMLElement {
  constructor() {
    super();
    this.json = JSON.parse(document.querySelector('.drawer__items').getAttribute('data-json'));
    
    this.toggle = this.querySelector('input');
    this.toggle.addEventListener('change', this.toggleGiftNote.bind(this));
    this.giftNoteInput = document.getElementById('gift-note');
    this.giftWrapInCart = this.getAttribute('data-has-gift-note') === 'true';
    this.giftNoteId = 32065742504054;
    
    this.init();

    if(!this.giftNoteInput) {
      console.log('no gift note input');
      return;
    }
    this.giftNoteInput.addEventListener('keyup', this.debounce(() => {
      console.log(this.giftNoteInput.value);
      let noteData = {
         attributes: {
           'Gift Note': this.giftNoteInput.value
         }
      };
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(noteData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },250));
  }
  
  debounce(callback, wait) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(function () { callback.apply(this, args); }, wait);
    };
  }
  
  init() {
    this.toggle.checked = this.giftWrapInCart;
  }
  giftNoteListener() {
    let timer;
    let interval = 250;
    clearTimeout
  }
  
  giftWrapInCart() {
    return this.giftWrapInCart;
  }
  removeGiftWrap() {
    let removeData = {
      id: this.giftNoteId.toString(),
      quantity: 0,
      note: ''
    }
    removeData.sections = "cart-drawer,cart-icon-bubble,main-cart-items";
    
	fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(removeData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        cartUpdate(data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  toggleGiftNote() {
    console.log('toggleGiftNote');
    const qty = event.target.checked ? 1 : 0;
    const itemObj = {
      items: [
        {
          id: this.giftNoteId,
          quantity: qty
        }
      ]
    }
    qty === 1 ? addToCart(itemObj) : this.removeGiftWrap();
  }
}

customElements.define('gift-note', GiftNoteToggle);